import React from "react";
import SocialMediaIcons from "../../component/appBarcomponent/SocialMediaIcons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logOut } from "../../store/authSlice";

import "../css/Home.css";
import LOGO from "../assets/thurent-logo.svg";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";

function Footer() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutAccount = () => {
    dispatch(logOut()); // Dispatch the logout action to clear user state
    navigate("/"); // Redirect the user to the login page after logging out
    window.location.reload();
  };

  return (
    <div className="th-footer">
      <div className="th-footer__block__1">
        <div className="th-footer__container">
          <div className="th-footer__hero">
            <img src={LOGO} alt="thurent" width={"120px"} />
            <span className="th-footer__text">
              Book your event in minute, get full Control for much longer.
            </span>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "16px",
              }}
            >
              <SocialMediaIcons />
            </div>
          </div>
        </div>
        <div className="th-footer__links">
          <span className="th-footer__links__title">Quick Links</span>
          <div className="th-footer__links__nav">
            <p
              className="th-footer__links__subtitle"
              onClick={() => navigate("/")}
            >
              Home
            </p>
            <p
              className="th-footer__links__subtitle"
              onClick={() => navigate("/about-us")}
            >
              About Us
            </p>
            <p
              className="th-footer__links__subtitle"
              onClick={() => navigate("/contact")}
            >
              Contact
            </p>
            <p
              className="th-footer__links__subtitle"
              onClick={() => navigate("/privacy-policy")}
            >
              Privacy policy
            </p>
            {!isLoggedIn ? (
              <p
                className="th-footer__links__subtitle"
                onClick={() => navigate("/login")}
              >
                Log-in / Sign-Up
              </p>
            ) : (
              <p className="th-footer__links__subtitle" onClick={logoutAccount}>
                Logout
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="th-footer__block">
        <div className="th-footer__links">
          <span className="th-footer__links__title">Services</span>
          <div className="th-footer__links__nav">
            <p
              className="th-footer__links__subtitle"
              onClick={() => navigate("/service/ai-enabled-event-details")}
            >
              AI Enabled Event Details
            </p>
            <p
              className="th-footer__links__subtitle"
              onClick={() => navigate("/service/book-catering")}
            >
              Order Catering
            </p>
            <p
              className="th-footer__links__subtitle"
              onClick={() => navigate("/service/rental-services-for-events")}
            >
              Rent from Tent Houses
            </p>
            <p
              className="th-footer__links__subtitle"
              onClick={() => navigate("/service/invite")}
            >
              Send Invitation
            </p>
            <p
              className="th-footer__links__subtitle"
              onClick={() => navigate("/service/hire-a-priest")}
            >
              Book A Priest
            </p>
          </div>
        </div>
        <div className="th-footer__links">
          <span className="th-footer__links__title">Contact</span>
          <div className="th-footer__links__nav">
            <p className="th-footer__links__subtitle">
              <i className="pi pi-phone"></i> +91 74167-34499
            </p>
            <p className="th-footer__links__subtitle">
              <i className="pi pi-map-marker"> </i> THURENT TECH SERVICES
              PRIVATE LIMITED
              <br /> 1-8-19/2, New Dilsukhnagar
              <br /> Hyderabad- 500060
              <br /> TELANGANA INDIA
            </p>
            <p className="th-footer__links__subtitle">
              <i className="pi pi-envelope"></i> nick@thurent.com
            </p>
          </div>
          <span className="th-footer__links__title">
            Subscribe to our newsletter
          </span>
          <IconField>
            <InputIcon className="pi pi-send"></InputIcon>
            <InputText
              placeholder="Enter your email"
              className="th-event__subtext th-newsletter w-full"
            />
          </IconField>
        </div>
      </div>
    </div>
  );
}

export default Footer;
